import {needAuth} from "../instance/Instance";
import {AxiosError} from "axios";
import {getParam} from "../../components/Utils/Utils";
import store from "../../redux/store/store";
import {apiLoading, error} from "../../redux/slice/apiSlice";
import {apiRequest} from "../../components/Utils/SimmsUtils";

const selectServiceApply = async (search, pageable) => {
    try {
        return await needAuth.post(`/serviceApply?${getParam(pageable)}`, search);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const getServiceApply = async (id) => {
    try {
        return await needAuth.get(`/serviceApply/${id}`);
    } catch (e) {
        if (e instanceof AxiosError) {
            const status = e.response.status;
            const data = e.response.data;
            if (status === 404) {
                store.dispatch(error({code: status}))
            }
            return {status, data}
        }
    } finally {
        store.dispatch(apiLoading(false));
    }
}

const saveServiceApply = async (data, files, success) => {
    const formData = new FormData();
    files.forEach(file => formData.append("files", file));
    formData.append("requestDto", new Blob([JSON.stringify(data)], {type: "application/json"}));

    return apiRequest(() => needAuth.post(`/serviceApply/create`,
            formData, {headers: {'Content-Type': 'multipart/form-data'}}), success
    );
}

const updateServiceApply = async (data) => {
    try {
        return await needAuth.put(`/serviceApply`, data);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const deleteServiceApply = async (ids) => {
    try {
        return await needAuth.put(`/serviceApply/delete`, ids);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}


export {selectServiceApply, getServiceApply, saveServiceApply, updateServiceApply, deleteServiceApply}

